import { render, staticRenderFns } from "./ProgramPanel.vue?vue&type=template&id=00fcf7b0&scoped=true&"
import script from "./ProgramPanel.vue?vue&type=script&lang=ts&"
export * from "./ProgramPanel.vue?vue&type=script&lang=ts&"
import style0 from "./ProgramPanel.vue?vue&type=style&index=0&id=00fcf7b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fcf7b0",
  null
  
)

export default component.exports